import { Container } from '@chakra-ui/react';
import Hero from '~/components/Hero';
import HtmlParser from '~/components/HtmlParser/HtmlParser';
import SectionWithTitle from '~/components/SectionWithTitle';
import Text from '~/components/Text';
import React from 'react';
import Layout from '../../components/Layout';
import SEO from '../../components/SEO';
import { getCurrentOrigin } from '../../utils/getCurrentDomain';
import { getSeoDataFromWordpressForPage } from '../../utils/getSeoData';
import { createImageWithArtDirection } from '../../utils/imageUtils';

var PostDefaultTemplate = function PostDefaultTemplate(props) {
  var _contentTypeData$lang, _contentTypeData$lang2, _contentTypeData$acfP, _contentTypeData$acfP2, _contentTypeData$acfP3, _contentTypeData$acfP4, _contentTypeData$acfP5, _contentTypeData$acfP6, _post$acfPost$hero$de, _post$acfPost$hero, _post$featuredImage, _post$acfPost$hero2, _contentTypeData$acfP7, _contentTypeData$acfP8, _contentTypeData$acfP9, _contentTypeData$acfP10, _contentTypeData$acfP11, _contentTypeData$acfP12, _contentTypeData$acfP13;

  var data = props.data;
  var pageContext = props.pageContext;
  var contentTypeData = data.wpPost;
  if (!contentTypeData || !(contentTypeData !== null && contentTypeData !== void 0 && contentTypeData.link) || !((_contentTypeData$lang = contentTypeData.language) !== null && _contentTypeData$lang !== void 0 && _contentTypeData$lang.slug) || !pageContext.defaultLanguage) return null;
  var seoProps = getSeoDataFromWordpressForPage({
    availableTranslations: contentTypeData.translations,
    currentLanguage: (_contentTypeData$lang2 = contentTypeData.language) === null || _contentTypeData$lang2 === void 0 ? void 0 : _contentTypeData$lang2.locale,
    currentOrigin: getCurrentOrigin(),
    defaultLanguage: pageContext.defaultLanguage,
    featuredImageUrl: (_contentTypeData$acfP = contentTypeData.acfPost) === null || _contentTypeData$acfP === void 0 ? void 0 : (_contentTypeData$acfP2 = _contentTypeData$acfP.hero) === null || _contentTypeData$acfP2 === void 0 ? void 0 : (_contentTypeData$acfP3 = _contentTypeData$acfP2.desktopFeaturedImage) === null || _contentTypeData$acfP3 === void 0 ? void 0 : (_contentTypeData$acfP4 = _contentTypeData$acfP3.localFile) === null || _contentTypeData$acfP4 === void 0 ? void 0 : (_contentTypeData$acfP5 = _contentTypeData$acfP4.childImageSharp) === null || _contentTypeData$acfP5 === void 0 ? void 0 : (_contentTypeData$acfP6 = _contentTypeData$acfP5.gatsbyImageData) === null || _contentTypeData$acfP6 === void 0 ? void 0 : _contentTypeData$acfP6.src,
    pagePath: props.location.pathname,
    pageSlug: contentTypeData.slug,
    seo: contentTypeData.seo
  });
  var post = contentTypeData;
  if (!post.acfPost) return null;
  var imageWithArtDirection = createImageWithArtDirection({
    desktopImage: (_post$acfPost$hero$de = (_post$acfPost$hero = post.acfPost.hero) === null || _post$acfPost$hero === void 0 ? void 0 : _post$acfPost$hero.desktopFeaturedImage) !== null && _post$acfPost$hero$de !== void 0 ? _post$acfPost$hero$de : (_post$featuredImage = post.featuredImage) === null || _post$featuredImage === void 0 ? void 0 : _post$featuredImage.node,
    mobileImage: (_post$acfPost$hero2 = post.acfPost.hero) === null || _post$acfPost$hero2 === void 0 ? void 0 : _post$acfPost$hero2.mobileFeaturedImage
  }); // legacy posts had manual formatting for font size and justified text

  var removeFontSizeFromContent = function removeFontSizeFromContent(content) {
    return content === null || content === void 0 ? void 0 : content.replace(/font-size: \d*pt;| style="text-align: justify;"/g, '');
  };

  var contentWithoutFontSizes = removeFontSizeFromContent(post.content);
  var postTitle = (_contentTypeData$acfP7 = contentTypeData.acfPost) !== null && _contentTypeData$acfP7 !== void 0 && (_contentTypeData$acfP8 = _contentTypeData$acfP7.hero) !== null && _contentTypeData$acfP8 !== void 0 && (_contentTypeData$acfP9 = _contentTypeData$acfP8.title) !== null && _contentTypeData$acfP9 !== void 0 && _contentTypeData$acfP9.length ? (_contentTypeData$acfP10 = contentTypeData.acfPost) === null || _contentTypeData$acfP10 === void 0 ? void 0 : (_contentTypeData$acfP11 = _contentTypeData$acfP10.hero) === null || _contentTypeData$acfP11 === void 0 ? void 0 : _contentTypeData$acfP11.title : contentTypeData.title;
  return /*#__PURE__*/React.createElement(Layout, {
    currentLanguage: contentTypeData.language,
    currentPath: contentTypeData.link,
    menuData: pageContext.menus,
    siteSettings: pageContext.siteSettings,
    translations: contentTypeData.translations
  }, /*#__PURE__*/React.createElement(SEO, seoProps), /*#__PURE__*/React.createElement(Hero, {
    heading: postTitle,
    backgroundImage: imageWithArtDirection,
    tagline: /*#__PURE__*/React.createElement(Text, {
      color: "white",
      fontWeight: "bold"
    }, contentTypeData.date)
  }), /*#__PURE__*/React.createElement(SectionWithTitle, {
    contentAlignment: "center",
    color: "text"
  }, /*#__PURE__*/React.createElement(Container, {
    maxW: "75ch",
    w: "100%"
  }, /*#__PURE__*/React.createElement(HtmlParser, {
    textBlock: true
  }, (_contentTypeData$acfP12 = (_contentTypeData$acfP13 = contentTypeData.acfPost) === null || _contentTypeData$acfP13 === void 0 ? void 0 : _contentTypeData$acfP13.content) !== null && _contentTypeData$acfP12 !== void 0 ? _contentTypeData$acfP12 : contentWithoutFontSizes))));
};

export default PostDefaultTemplate;
var query = "1069783344";